import { useCaseOutputQueries } from '@/data/Cases/useCaseOutputQueries'
import { computed, type Ref } from 'vue'

/**
 * Gets all loaded outputs for a given Case ID.
 *
 * Doesn't provide a loading state or errors. For that, use the `useCaseOutputQueries` query directly.
 */
export const useCaseOutputs = ({
  caseId,
  workspaceId,
}: {
  caseId: Ref<string | undefined | null>
  workspaceId: Ref<string>
}) => {
  const caseOutputQueries = useCaseOutputQueries(caseId, workspaceId)

  return computed(() => caseOutputQueries.value.map((query) => query.data).filter((d) => !!d))
}
